import { TripMember } from '../types/trip';

/**
 * Filter to "display members" — people who should appear in dropdowns,
 * expense splits, travel lists, RSVP lists, etc.
 *
 * Includes:
 * - Planner (role: 'planner', isAnonymous: false)
 * - Planner-created crew placeholders (isAnonymous: false)
 * - Self-added crew via "My name isn't here" (isAnonymous: false, claimedBy: self)
 *
 * Excludes:
 * - Stale anonymous "Guest" entries from the old auto-join flow
 *   (isAnonymous: true, no claimedBy)
 */
export function getDisplayMembers(members: Record<string, TripMember>): TripMember[] {
  return Object.values(members).filter(isDisplayMember);
}

export function getDisplayMemberEntries(members: Record<string, TripMember>): [string, TripMember][] {
  return Object.entries(members).filter(([, m]) => isDisplayMember(m));
}

function isDisplayMember(m: TripMember): boolean {
  return !m.isAnonymous || !!m.claimedBy;
}
